import u from "lodash/isArrayLikeObject";
import l from "uuid";
import { arrayHasItems as c } from "./helpers.js";
import a from "./date-info.js";
class m {
  constructor({ key: e, dates: s, excludeDates: i, excludeMode: n, pinPage: r }, h) {
    this.key = e === void 0 ? l() : e, this.pinPage = r, s && (this.dates = u(s) ? s : [s]), this.hasDates = c(this.dates), i && (this.excludeDates = u(i) ? i : [i]), this.hasExcludeDates = c(this.excludeDates), this.excludeMode = n || "intersects", this.dates = (this.hasDates && this.dates || this.hasExcludeDates && [{}] || []).map((t) => t && (t instanceof a ? t : new a(t, { locale: h }))).filter((t) => t), this.excludeDates = (this.hasExcludeDates && this.excludeDates || []).map((t) => t && (t instanceof a ? t : new a(t, { locale: h }))).filter((t) => t), this.isComplex = [s].some((t) => t.isComplex);
  }
  // Accepts: Date or date range object
  // Returns: First attribute date info that partially intersects the given date
  intersectsDate(e) {
    return !this.excludesDate(e) && (this.dates.find((s) => s.intersectsDate(e)) || !1);
  }
  // Accepts: Date or date range object
  // Returns: First attribute date info that completely includes the given date
  includesDate(e) {
    return !this.excludesDate(e) && (this.dates.find((s) => s.includesDate(e)) || !1);
  }
  excludesDate(e) {
    return this.hasExcludeDates && this.excludeDates.find(
      (s) => this.excludeMode === "intersects" && s.intersectsDate(e) || this.excludeMode === "includes" && s.includesDate(e)
    );
  }
  // Accepts: Day object
  // Returns: First attribute date info that occurs on given day.
  includesDay(e) {
    return !this.excludesDay(e) && (this.dates.find((s) => s.includesDay(e)) || !1);
  }
  excludesDay(e) {
    return this.hasExcludeDates && this.excludeDates.find((s) => s.includesDay(e));
  }
}
export {
  m as default
};
//# sourceMappingURL=attribute.js.map
